const numberPhoneValidator = (value, options) => {
  if (!value) return null;

  let ddd = value
    .toString()
    .substr(value.toString().indexOf('('), 3)
    .replace('(', '')
    .replace(' ', '');
  let restoNumero = value
    .toString()
    .substr(value.toString().indexOf(')'))
    .replace(')', '')
    .replace(' ', '');

  let ddds = [
    11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35,
    37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64,
    65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88,
    89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
  ];

  value = value
    .toString()
    .replace('(', '')
    .replace(')', '')
    .replace('-', '')
    .replace(' ', '');

  if (
    value === '00000000000' ||
    value === '11111111111' ||
    value === '22222222222' ||
    value === '33333333333' ||
    value === '44444444444' ||
    value === '55555555555' ||
    value === '66666666666' ||
    value === '77777777777' ||
    value === '88888888888' ||
    value === '99999999999'
  )
    return options.message;

  if (restoNumero[0] !== '9') return options.message;

  let filtro = ddds.filter((d) => d.toString() === ddd);
  if (filtro.length === 0) return options.message;

  if (value.toString().match(/\d/g).join([]).length !== 11) {
    return options.message;
  }

  return null;
};

export default numberPhoneValidator;
